import React from 'react';
import Typography from '@/components/shared/Typography';
import Banner from '../shared/Banner';
import Button from '../shared/Button';
import { useViewport } from '@/hooks/useViewport';
import router from 'next/router';

type AdvantagesProps = {
  src: string;
  text: string;
  title: string;
};

const Advantages = ({ title, text, src }: AdvantagesProps) => {
  return (
    <div className="flex xl:flex-row flex-col xl:justify-between justify-center text-center xl:text-left items-center xl:mt-0 mt-8">
      <div className="mr-3">
        <img src={src} alt="advantages" />
      </div>
      <div className="xl:w-324 ml-3 pr-3 xl:mt-0 mt-5">
        <Typography type="caption" className="uppercase">
          {title}
        </Typography>
        <Typography type="b3">{text}</Typography>
      </div>
    </div>
  );
};

const AboutOurBooks: React.FC = () => {
  const { isMobile } = useViewport();

  return (
    <Banner
      height={isMobile ? 1388 : 700}
      className="block pt-20"
      backgroundImage="url('/images/general/greece.jpg')"
    >
      <div className="xl:w-969 w-80 xl:h-508 rounded-3xl bg-white flex xl:flex-row flex-col xl:justify-between xl:pl-14 xl:pt-14 xl:pr-12 xl:pb-18 pb-7 px-6 pt-12 justify-center mx-auto">
        <div className="xl:text-left flex flex-col xl:items-start items-center text-center">
          <Typography type={isMobile ? 'mh1' : 'h2'}>
            About our Books
          </Typography>
          <div className="xl:w-357 w-273 xl:text-left text-center mt-5 xl:mb-7">
            <Typography type="b3">
              Our stories are full of beautiful illustrations, adventure, lots
              of diverse characters, and so much fun!
            </Typography>
            <Typography type="b3" className="pt-8">
              We&apos;re committed to creating plot based stories that build
              your child&apos;s self-esteem and empathy with adventure, lots of
              diverse characters, and so much fun!
              {/* We&apos;re committed to creating plot based stories that build
              your child&apos;s self-esteem and empathy.ns, adventure, lots of
              diverse characters, and so much fun! */}
            </Typography>
          </div>
          <Button
            className=" w-134 h-12 hidden xl:block"
            aria-label="Shop now"
            onClick={() => {
              router.push('/shop');
            }}
          >
            Shop Now
          </Button>
        </div>
        <div>
          <Advantages
            title="Build Self Esteem"
            text="Your Keepsake Tale is designed to build your child's self-esteem, helping them to understand their intrinsic value and self-worth."
            src="/images/aboutOurBooks/couple.png"
          />
          <div className="xl:my-7">
            <Advantages
              title="Cultivate Empathy"
              text="At Keepsake Tales, we believe that our world could use a healthy dose of empathy. We design our stories to help every child develop empathy for others who may not look like them."
              src="/images/aboutOurBooks/planet.png"
            />
          </div>
          <Advantages
            title="Jump Into The Story!"
            text="We believe that stories are powerful. At Keepsake Tales, your child will always be the main character of a plot-based story."
            src="/images/aboutOurBooks/hands-heart.png"
          />
        </div>
        <Button
          className="h-12 xl:hidden mt-10"
          aria-label="Shop now"
          onClick={() => {
            router.push('/shop');
          }}
        >
          Shop Now
        </Button>
      </div>
    </Banner>
  );
};

export default AboutOurBooks;
